// @flow

import { fetchJson } from 'utils/fetch';

export const fetchUsers = () => fetchJson('/mc/messaging/users.json');



// WEBPACK FOOTER //
// ./src/modules/messaging/api/users.js